import { createReducer } from 'redux-create-reducer'
import type { ClientLibrary, ClientLibraryId } from 'types/client-library'
import {
  CLIENT_LIBRARY_ALBUMS_LOAD,
  CLIENT_LIBRARY_ALBUMS_LOAD_FAIL,
  CLIENT_LIBRARY_ALBUMS_LOAD_NEXT,
  CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_FAIL,
  CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_SUCCESS,
  CLIENT_LIBRARY_ALBUMS_LOAD_SUCCESS,
  CLIENT_LIBRARY_ALBUMS_UPDATE,
  CLIENT_LIBRARY_ARTIST_LOAD,
  CLIENT_LIBRARY_ARTIST_LOAD_FAIL,
  CLIENT_LIBRARY_ARTIST_LOAD_SUCCESS,
  CLIENT_LIBRARY_ARTIST_TRACKS_LOAD,
  CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_FAIL,
  CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_SUCCESS,
  CLIENT_LIBRARY_ARTIST_UPDATE,
  CLIENT_LIBRARY_ARTISTS_LOAD,
  CLIENT_LIBRARY_ARTISTS_LOAD_FAIL,
  CLIENT_LIBRARY_ARTISTS_LOAD_NEXT,
  CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_FAIL,
  CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_SUCCESS,
  CLIENT_LIBRARY_ARTISTS_LOAD_SUCCESS,
  CLIENT_LIBRARY_CLIENT_DELETE,
  CLIENT_LIBRARY_CLIENT_UPDATE,
  CLIENT_LIBRARY_CLIENT_UPDATE_FAIL,
  CLIENT_LIBRARY_CLIENT_UPDATE_SUCCESS,
  CLIENT_LIBRARY_CLIENTS_INVITE_SUCCESS,
  CLIENT_LIBRARY_CLIENTS_LOAD,
  CLIENT_LIBRARY_CLIENTS_LOAD_FAIL,
  CLIENT_LIBRARY_CLIENTS_LOAD_SUCCESS,
  CLIENT_LIBRARY_CLIENTS_RESET_ERRORS,
  CLIENT_LIBRARY_CONTENT_LOAD_SUCCESS,
  CLIENT_LIBRARY_CONTENT_UPDATE,
  CLIENT_LIBRARY_FEATURED_ALBUMS_SET,
  CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE,
  CLIENT_LIBRARY_FEATURED_ARTISTS_SET,
  CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET,
  CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE,
  CLIENT_LIBRARY_FEATURED_TRACKS_LOAD,
  CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_FAIL,
  CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_SUCCESS,
  CLIENT_LIBRARY_IMAGES_UPDATE_SUCCESS,
  CLIENT_LIBRARY_LIST_CREATE_FAIL,
  CLIENT_LIBRARY_LIST_DELETE,
  CLIENT_LIBRARY_LIST_GET,
  CLIENT_LIBRARY_LIST_GET_ALL,
  CLIENT_LIBRARY_LIST_GET_ALL_FAIL,
  CLIENT_LIBRARY_LIST_GET_ALL_SUCCESS,
  CLIENT_LIBRARY_LIST_GET_FAIL,
  CLIENT_LIBRARY_LIST_GET_SUCCESS,
  CLIENT_LIBRARY_PLAYLISTS_LOAD,
  CLIENT_LIBRARY_PLAYLISTS_LOAD_FAIL,
  CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT,
  CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_FAIL,
  CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_SUCCESS,
  CLIENT_LIBRARY_PLAYLISTS_LOAD_SUCCESS,
  CLIENT_LIBRARY_PLAYLISTS_UPDATE,
  CLIENT_LIBRARY_STATS_LOAD,
  CLIENT_LIBRARY_STATS_LOAD_FAIL,
  CLIENT_LIBRARY_STATS_LOAD_SUCCESS,
  CLIENT_LIBRARY_TRACKS_LOAD,
  CLIENT_LIBRARY_TRACKS_LOAD_FAIL,
  CLIENT_LIBRARY_TRACKS_LOAD_NEXT,
  CLIENT_LIBRARY_TRACKS_LOAD_NEXT_FAIL,
  CLIENT_LIBRARY_TRACKS_LOAD_NEXT_SUCCESS,
  CLIENT_LIBRARY_TRACKS_LOAD_SUCCESS,
  CLIENT_LIBRARY_TRACKS_SET,
  CLIENT_LIBRARY_TRACKS_UPDATE,
  CLIENT_LIBRARY_UPDATE_SUCCESS,
} from '@disco/constants/ActionTypes'
import { pick } from '@disco/utils/array'
import { deleteItem, updateItem } from '@disco/utils/immutable'
export type State = {
  error: Error | null | undefined
  loading: boolean
  loaded: boolean
  items: Record<ClientLibraryId, ClientLibrary>
}
const initialState: State = {
  error: null,
  loading: false,
  loaded: false,
  items: {},
}
const initialPaginatedState = {
  loading: false,
  loaded: false,
  nextPage: null,
  items: {},
  list: [],
}
// TODO: Refactor library artists and playlists
const initialPaginatedState2 = {
  items: {},
  all: {
    loading: false,
    loaded: false,
    nextPage: null,
    list: [],
  },
  featured: {
    loading: false,
    loaded: false,
    nextPage: null,
    list: [],
  },
}

function update(
  state: State,
  libraryId: ClientLibraryId,
  updated: Record<string, any>,
): State {
  return {
    ...state,
    // @ts-expect-error - fix later
    items: {
      ...state.items,
      [libraryId]: { ...(state.items[libraryId] || {}), ...updated },
    },
  }
}

export const librariesReducer = createReducer<State, any>(initialState, {
  [CLIENT_LIBRARY_LIST_CREATE_FAIL](
    state: State,
    { error }: Record<string, any>,
  ) {
    return { ...state, error }
  },

  [CLIENT_LIBRARY_LIST_DELETE](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const items = { ...state.items }
    delete items[libraryId]
    return { ...state, items }
  },

  [CLIENT_LIBRARY_LIST_GET_ALL](state: State) {
    return { ...state, error: null, loading: true }
  },

  [CLIENT_LIBRARY_LIST_GET_ALL_SUCCESS](
    state: State,
    { response }: Record<string, any>,
  ) {
    const updatedClientLibraries = {}
    response.results.forEach(library => {
      updatedClientLibraries[library.id] = {
        ...library,
        albums: initialPaginatedState,
        artists: initialPaginatedState,
        playlists: initialPaginatedState,
        tracks: initialPaginatedState2,
        clients: state.items[library.id]?.clients || {
          errors: {},
          list: [],
        },
        stats: state.items[library.id]?.stats,
        content: state.items[library.id]?.content || [],
      }
    })
    return {
      ...state,
      error: null,
      loaded: true,
      loading: false,
      items: updatedClientLibraries,
    }
  },

  [CLIENT_LIBRARY_LIST_GET_ALL_FAIL](
    state: State,
    { error }: Record<string, any>,
  ) {
    return { ...state, error, loading: false }
  },

  [CLIENT_LIBRARY_LIST_GET](state: State, { libraryId }: Record<string, any>) {
    return update(state, libraryId, {
      loading: true,
      loadingError: null,
    })
  },

  [CLIENT_LIBRARY_LIST_GET_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    return update(state, libraryId, {
      ...response,
      loading: false,
      albums: library?.albums || initialPaginatedState,
      artists: library?.artists || initialPaginatedState,
      playlists: library?.playlists || initialPaginatedState,
      tracks: library?.tracks || initialPaginatedState2,
      clients: library?.clients || {
        errors: {},
        list: [],
      },
      content: library?.content || [],
    })
  },

  [CLIENT_LIBRARY_LIST_GET_FAIL](
    state: State,
    { libraryId, error }: Record<string, any>,
  ) {
    return update(state, libraryId, {
      loading: false,
      loadingError: error,
    })
  },

  [CLIENT_LIBRARY_CONTENT_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const content = response.results
      .filter(item => item['is_client_library_content'] === true)
      .map(item => item.id)
    return update(state, libraryId, {
      content,
    })
  },

  [CLIENT_LIBRARY_CONTENT_UPDATE](
    state: State,
    { libraryId, payload }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const content = library.content
      ? library.content
          .filter(id => !payload['to_remove'].includes(id))
          .concat(payload['to_add'])
      : []
    return update(state, libraryId, {
      content,
    })
  },

  [CLIENT_LIBRARY_ALBUMS_LOAD](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const albums = {
      ...(library.albums ?? initialPaginatedState),
      loading: true,
      loaded: false,
      nextPage: null,
      list: [],
    }
    return update(state, libraryId, {
      albums,
    })
  },

  [CLIENT_LIBRARY_ALBUMS_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const results = response.results.map(item =>
      pick(item, ['playlist_id', 'is_featured']),
    )
    const albums = {
      loading: false,
      loaded: true,
      nextPage: response.next,
      items: results.reduce(
        (items, album) => ({ ...items, [album['playlist_id']]: album }),
        {},
      ),
      list: results.map(album => album['playlist_id']),
    }
    return update(state, libraryId, {
      albums,
    })
  },

  [CLIENT_LIBRARY_ALBUMS_LOAD_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const albums = {
      ...(library.albums ?? initialPaginatedState),
      loading: false,
    }
    return update(state, libraryId, {
      albums,
    })
  },

  [CLIENT_LIBRARY_ALBUMS_LOAD_NEXT](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const albums = {
      ...(library.albums ?? initialPaginatedState),
      loading: true,
    }
    return update(state, libraryId, {
      albums,
    })
  },

  [CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const results = response.results.map(item =>
      pick(item, ['playlist_id', 'is_featured']),
    )
    const albums = {
      loading: false,
      loaded: true,
      nextPage: response.next,
      items: {
        ...library.albums?.items,
        ...results.reduce(
          (items, album) => ({ ...items, [album['playlist_id']]: album }),
          {},
        ),
      },
      list: [
        ...(library.albums?.list ?? []),
        ...results.map(album => album['playlist_id']),
      ],
    }
    return update(state, libraryId, {
      albums,
    })
  },

  [CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const albums = {
      ...(library.albums ?? initialPaginatedState),
      loading: false,
    }
    return update(state, libraryId, {
      albums,
    })
  },

  [CLIENT_LIBRARY_ALBUMS_UPDATE](
    state: State,
    { libraryId, payload }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const items = { ...library.albums?.items }
    const list = [...(library.albums?.list ?? [])].filter(
      playlistId => !payload['to_remove'].includes(playlistId),
    )
    payload['to_add'].forEach(playlistId => {
      if (!items[playlistId]) {
        items[playlistId] = {
          playlist_id: playlistId,
          is_featured: false,
        }
      }

      if (!list.includes(playlistId)) {
        list.unshift(playlistId)
      }
    })
    payload['to_remove'].forEach(playlistId => {
      if (items[playlistId]) {
        delete items[playlistId]
      }
    })
    return update(state, libraryId, {
      albums: { ...(library.albums ?? initialPaginatedState), items, list },
    })
  },

  [CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE](
    state: State,
    { libraryId, payload }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const items = { ...library.albums?.items }
    payload['to_add'].forEach(playlistId => {
      items[playlistId] = { ...items[playlistId], is_featured: true }
    })
    payload['to_remove'].forEach(playlistId => {
      items[playlistId] = { ...items[playlistId], is_featured: false }
    })
    return update(state, libraryId, {
      albums: {
        ...(library.albums ?? initialPaginatedState),
        items,
        list:
          library.albums?.list?.filter(
            playlistId => !payload['to_remove'].includes(playlistId),
          ) ?? [],
      },
    })
  },

  [CLIENT_LIBRARY_FEATURED_ALBUMS_SET](
    state: State,
    { libraryId, playlistIds }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    return update(state, libraryId, {
      albums: {
        ...(library.albums ?? initialPaginatedState),
        list: playlistIds,
      },
    })
  },

  [CLIENT_LIBRARY_ARTISTS_LOAD](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artists = {
      ...(library.artists ?? initialPaginatedState),
      loading: true,
      loaded: false,
      nextPage: null,
      list: [],
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTISTS_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const results = response.results.map(item =>
      pick(item, ['id', 'is_featured', 'tracks']),
    )
    const artists = {
      loading: false,
      loaded: true,
      nextPage: response.next,
      items: {
        ...library.artists?.items,
        ...results.reduce(
          (items, artist) => ({
            ...items,
            [artist['id']]: {
              ...library.artists?.items[artist['id']],
              ...artist,
            },
          }),
          {},
        ),
      },
      list: results.map(artist => artist['id']),
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTISTS_LOAD_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artists = {
      ...(library.artists ?? initialPaginatedState),
      loading: false,
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTISTS_LOAD_NEXT](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artists = {
      ...(library.artists ?? initialPaginatedState),
      loading: true,
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const results = response.results.map(item =>
      pick(item, ['id', 'is_featured', 'tracks']),
    )
    const artists = {
      loading: false,
      loaded: true,
      nextPage: response.next,
      items: {
        ...library.artists?.items,
        ...results.reduce(
          (items, artist) => ({
            ...items,
            [artist['id']]: {
              ...library.artists?.items[artist['id']],
              ...artist,
            },
          }),
          {},
        ),
      },
      list: [
        ...(library.artists?.list ?? []),
        ...results.map(artist => artist['id']),
      ],
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artists = {
      ...(library.artists ?? initialPaginatedState),
      loading: false,
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_FEATURED_ARTISTS_SET](
    state: State,
    { libraryId, artistIds }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    return update(state, libraryId, {
      artists: { ...library.artists, list: artistIds },
    })
  },

  [CLIENT_LIBRARY_ARTIST_LOAD](
    state: State,
    { libraryId, artistId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artists = {
      ...(library.artists ?? initialPaginatedState),
      items: {
        ...library.artists?.items,
        [artistId]: { ...library.artists?.items[artistId], loading: true },
      },
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTIST_LOAD_SUCCESS](
    state: State,
    { libraryId, artistId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artist = pick(response, ['id', 'is_featured'])
    return update(state, libraryId, {
      artists: {
        ...library.artists,
        items: {
          ...library.artists?.items,
          [artistId]: { ...artist, loading: false },
        },
      },
    })
  },

  [CLIENT_LIBRARY_ARTIST_LOAD_FAIL](
    state: State,
    { libraryId, artistId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artists = {
      ...library.artists,
      items: {
        ...library.artists?.items,
        [artistId]: { ...library.artists?.items[artistId], loading: false },
      },
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTIST_UPDATE](
    state: State,
    { libraryId, artistId, data }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const artists = {
      ...library.artists,
      items: {
        ...library.artists?.items,
        [artistId]: { ...library.artists?.items[artistId], ...data },
      },
    }
    return update(state, libraryId, {
      artists,
    })
  },

  [CLIENT_LIBRARY_ARTIST_TRACKS_LOAD](
    state: State,
    { libraryId, artistId, next }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    return update(state, libraryId, {
      artists: {
        ...library.artists,
        items: {
          ...library.artists?.items,
          [artistId]: {
            ...library.artists?.items[artistId],
            tracks: {
              error: null,
              items: next
                ? library.artists?.items[artistId]?.tracks?.items
                : {},
              loading: true,
              list: next ? library.artists?.items[artistId]?.tracks?.list : [],
              next: next || null,
            },
          },
        },
      },
    })
  },

  [CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_SUCCESS](
    state: State,
    { libraryId, artistId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const tracks = response.results.map(item =>
      pick(item, ['id', 'is_featured', 'order']),
    )
    return update(state, libraryId, {
      artists: {
        ...library.artists,
        items: {
          ...library.artists?.items,
          [artistId]: {
            ...library.artists?.items[artistId],
            tracks: {
              items: {
                ...library.artists?.items[artistId]?.tracks?.items,
                ...tracks.reduce(
                  (items, track) => ({ ...items, [track['id']]: track }),
                  {},
                ),
              },
              list: [
                ...(library.artists?.items[artistId]?.tracks?.list ?? []),
                ...tracks.map(track => track['id']),
              ],
              loading: false,
              next: response.next,
            },
          },
        },
      },
    })
  },

  [CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_FAIL](
    state: State,
    { libraryId, artistId, error }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    return update(state, libraryId, {
      artists: {
        ...library.artists,
        items: {
          ...library.artists?.items,
          [artistId]: {
            ...library.artists?.items[artistId],
            tracks: {
              ...library.artists?.items[artistId]?.tracks,
              error,
              loading: false,
            },
          },
        },
      },
    })
  },

  [CLIENT_LIBRARY_PLAYLISTS_LOAD](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const playlists = {
      ...(library.playlists ?? initialPaginatedState),
      loading: true,
      loaded: false,
      nextPage: null,
      list: [],
    }
    return update(state, libraryId, {
      playlists,
    })
  },

  [CLIENT_LIBRARY_PLAYLISTS_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const results = response.results.map(item =>
      pick(item, ['playlist_id', 'is_featured']),
    )
    const playlists = {
      loading: false,
      loaded: true,
      nextPage: response.next,
      items: results.reduce(
        (items, playlist) => ({
          ...items,
          [playlist['playlist_id']]: playlist,
        }),
        {},
      ),
      list: results.map(playlist => playlist['playlist_id']),
    }
    return update(state, libraryId, {
      playlists,
    })
  },

  [CLIENT_LIBRARY_PLAYLISTS_LOAD_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const playlists = {
      ...(library.playlists ?? initialPaginatedState),
      loading: false,
    }
    return update(state, libraryId, {
      playlists,
    })
  },

  [CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const playlists = {
      ...(library.playlists ?? initialPaginatedState),
      loading: true,
    }
    return update(state, libraryId, {
      playlists,
    })
  },

  [CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const results = response.results.map(item =>
      pick(item, ['playlist_id', 'is_featured']),
    )
    const playlists = {
      loading: false,
      loaded: true,
      nextPage: response.next,
      items: {
        ...library.playlists?.items,
        ...results.reduce(
          (items, playlist) => ({
            ...items,
            [playlist['playlist_id']]: playlist,
          }),
          {},
        ),
      },
      list: [
        ...(library.playlists?.list ?? []),
        ...results.map(playlist => playlist['playlist_id']),
      ],
    }
    return update(state, libraryId, {
      playlists,
    })
  },

  [CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const playlists = {
      ...(library.playlists ?? initialPaginatedState),
      loading: false,
    }
    return update(state, libraryId, {
      playlists,
    })
  },

  [CLIENT_LIBRARY_PLAYLISTS_UPDATE](
    state: State,
    { libraryId, payload }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const items = { ...library.playlists?.items }
    const list = [...(library.playlists?.list ?? [])].filter(
      playlistId => !payload['to_remove'].includes(playlistId),
    )
    payload['to_add'].forEach(playlistId => {
      if (!items[playlistId]) {
        items[playlistId] = {
          playlist_id: playlistId,
          is_featured: false,
        }
      }

      if (!list.includes(playlistId)) {
        list.unshift(playlistId)
      }
    })
    payload['to_remove'].forEach(playlistId => {
      if (items[playlistId]) {
        delete items[playlistId]
      }
    })
    return update(state, libraryId, {
      playlists: { ...library.playlists, items, list },
    })
  },

  [CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE](
    state: State,
    { libraryId, payload }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const items = { ...library.playlists?.items }
    payload['to_add'].forEach(playlistId => {
      items[playlistId] = { ...items[playlistId], is_featured: true }
    })
    payload['to_remove'].forEach(playlistId => {
      items[playlistId] = { ...items[playlistId], is_featured: false }
    })
    return update(state, libraryId, {
      playlists: {
        ...library.playlists,
        items,
        list:
          library.playlists?.list?.filter(
            playlistId => !payload['to_remove'].includes(playlistId),
          ) || [],
      },
    })
  },

  [CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET](
    state: State,
    { libraryId, playlistIds }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    return update(state, libraryId, {
      playlists: { ...library.playlists, list: playlistIds },
    })
  },

  [CLIENT_LIBRARY_TRACKS_LOAD](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const tracks = {
      ...(library.tracks ?? initialPaginatedState2),
      all: {
        loading: true,
        loaded: false,
        nextPage: null,
        list: [],
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_TRACKS_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const results = response.results.map(item =>
      pick(item, ['id', 'is_featured']),
    )
    const tracks = {
      ...library.tracks,
      items: {
        ...library.tracks?.items,
        ...results.reduce(
          (items, track) => ({ ...items, [track['id']]: track }),
          {},
        ),
      },
      all: {
        loading: false,
        loaded: true,
        nextPage: response.next,
        list: results.map(track => track['id']),
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_TRACKS_LOAD_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const tracks = {
      ...(library.tracks ?? initialPaginatedState2),
      all: {
        ...(library.tracks?.all ?? initialPaginatedState2.all),
        loading: false,
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_TRACKS_LOAD_NEXT](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const tracks = {
      ...(library.tracks ?? initialPaginatedState2),
      all: { ...library.tracks?.all, loading: true },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_TRACKS_LOAD_NEXT_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const results = response.results.map(item =>
      pick(item, ['id', 'is_featured']),
    )
    const tracks = {
      ...library.tracks,
      items: {
        ...library.tracks?.items,
        ...results.reduce(
          (items, track) => ({ ...items, [track['id']]: track }),
          {},
        ),
      },
      all: {
        loading: false,
        loaded: true,
        nextPage: response.next,
        list: [
          ...(library.tracks?.all?.list ?? []),
          ...results.map(track => track['id']),
        ],
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_TRACKS_LOAD_NEXT_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const tracks = {
      ...(library.tracks ?? initialPaginatedState2),
      all: {
        ...(library.tracks?.all ?? initialPaginatedState2.all),
        loading: false,
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_FEATURED_TRACKS_LOAD](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const tracks = {
      ...(library.tracks ?? initialPaginatedState2),
      featured: {
        loading: true,
        loaded: false,
        nextPage: null,
        list: [],
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const results = response.results.map(item =>
      pick(item, ['id', 'is_featured']),
    )
    const tracks = {
      ...library.tracks,
      items: {
        ...library.tracks?.items,
        ...results.reduce(
          (items, track) => ({ ...items, [track['id']]: track }),
          {},
        ),
      },
      featured: {
        loading: false,
        loaded: true,
        nextPage: response.next,
        list: results.map(track => track['id']),
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const tracks = {
      ...(library.tracks ?? initialPaginatedState2),
      featured: {
        ...(library.tracks?.featured ?? initialPaginatedState2.featured),
        loading: false,
      },
    }
    return update(state, libraryId, {
      tracks,
    })
  },

  [CLIENT_LIBRARY_TRACKS_UPDATE](
    state: State,
    { libraryId, payload }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const items = { ...library.tracks?.items }
    payload['to_add'].forEach(trackId => {
      // track may already exist in items; id falls back to trackId if not
      items[trackId] = { id: trackId, ...items[trackId], is_featured: true }
    })
    payload['to_remove'].forEach(trackId => {
      // track exists in items since it was previously featured
      items[trackId] = { id: trackId, ...items[trackId], is_featured: false }
    })
    return update(state, libraryId, {
      tracks: {
        ...library.tracks,
        featured: {
          ...library.tracks?.featured,
          list:
            library.tracks?.featured?.list?.filter(
              trackId => !payload['to_remove'].includes(trackId),
            ) ?? [],
        },
        items,
      },
    })
  },

  [CLIENT_LIBRARY_TRACKS_SET](
    state: State,
    { libraryId, trackIds }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    return update(state, libraryId, {
      tracks: {
        ...library.tracks,
        featured: { ...library.tracks?.featured, list: trackIds },
      },
    })
  },

  [CLIENT_LIBRARY_CLIENTS_LOAD](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const clients = {
      errors: {},
      loading: true,
      loaded: false,
      list: [],
    }
    return update(state, libraryId, {
      clients,
    })
  },

  [CLIENT_LIBRARY_CLIENTS_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const clients = {
      ...library.clients,
      loading: false,
      loaded: true,
      list: response.results,
    }
    return update(state, libraryId, {
      clients,
    })
  },

  [CLIENT_LIBRARY_CLIENTS_LOAD_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const clients = { ...library.clients, loading: false }
    return update(state, libraryId, {
      clients,
    })
  },

  [CLIENT_LIBRARY_CLIENTS_INVITE_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const list = library.clients?.list ?? []
    return update(state, libraryId, {
      clients: { ...library.clients, list: [...list, ...response] },
    })
  },

  [CLIENT_LIBRARY_CLIENTS_RESET_ERRORS](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    return update(state, libraryId, {
      clients: { ...library.clients, errors: {} },
    })
  },

  [CLIENT_LIBRARY_CLIENT_DELETE](
    state: State,
    { libraryId, clientId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const list = library.clients?.list ?? []
    const index = list.findIndex(client => client['id'] === clientId)
    return update(state, libraryId, {
      clients: { ...library.clients, list: deleteItem(list, index) },
    })
  },

  [CLIENT_LIBRARY_CLIENT_UPDATE](
    state: State,
    { libraryId, clientId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const list = library.clients?.list ?? []
    const index = list.findIndex(client => client['id'] === clientId)
    return index < 0
      ? state
      : update(state, libraryId, {
          clients: {
            ...library.clients,
            // index was verified >= 0, so list[index] is defined
            list: updateItem(list, index, { ...list[index]!, updating: true }),
          },
        })
  },

  [CLIENT_LIBRARY_CLIENT_UPDATE_SUCCESS](
    state: State,
    { libraryId, clientId, data }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const list = library.clients?.list ?? []
    const index = list.findIndex(client => client['id'] === clientId)
    return index < 0
      ? state
      : update(state, libraryId, {
          clients: {
            ...library.clients,
            // index was verified >= 0, so list[index] is defined
            list: updateItem(list, index, {
              ...list[index]!,
              ...data,
              updating: false,
            }),
          },
        })
  },

  [CLIENT_LIBRARY_CLIENT_UPDATE_FAIL](
    state: State,
    { libraryId, clientId, error }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const list = library.clients?.list ?? []
    const index = list.findIndex(client => client['id'] === clientId)
    const clients =
      index < 0
        ? { ...library.clients, errors: error }
        : {
            ...library.clients,
            // index was verified >= 0, so list[index] is defined
            list: updateItem(list, index, { ...list[index]!, updating: false }),
            errors: error,
          }
    return update(state, libraryId, {
      clients,
    })
  },

  [CLIENT_LIBRARY_STATS_LOAD](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const stats = {
      loading: true,
    }
    return update(state, libraryId, {
      stats,
    })
  },

  [CLIENT_LIBRARY_STATS_LOAD_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    const stats = { ...response, loading: false }
    return update(state, libraryId, {
      stats,
    })
  },

  [CLIENT_LIBRARY_STATS_LOAD_FAIL](
    state: State,
    { libraryId }: Record<string, any>,
  ) {
    const library = state.items[libraryId]
    if (!library) return state
    const stats = { ...library.stats, loading: false }
    return update(state, libraryId, {
      stats,
    })
  },

  [CLIENT_LIBRARY_UPDATE_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    return update(state, libraryId, { ...response })
  },

  [CLIENT_LIBRARY_IMAGES_UPDATE_SUCCESS](
    state: State,
    { libraryId, response }: Record<string, any>,
  ) {
    return update(state, libraryId, { ...response })
  },
})
